import * as React from 'react';
import { useParams } from 'react-router';
/* import { InterviewPageType } from '../../../utils/context/DeliveryContext';

import { useDeliveryContext } from '../../../utils/hooks/useDeliveryContext'; */
import { Seo } from '../../../../utils/seo/Index';
import { FooterOverride } from '../../../layout/FooterOverride';
import { Page } from '../../../layout/Page';
import { Button } from '../../../ui/button/Button';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { ButtonGroupColumn } from '../../../ui/button/ButtonGroupColumn';
import { Hero } from '../../../ui/hero/Index';
import { Heading } from '../../../ui/text/Heading';
import { InterviewContent } from './InterviewContent';
/* import { InterviewForm } from './InterviewForm'; */

import { InterviewList } from './InterviewList';
import { InterviewQuote } from './InterviewQuote';
import { InterviewTextLeft } from './InterviewTextLeft';
import { InterviewTextRight } from './InterviewTextRight';
import { InterviewTypeImage } from './InterviewTypeImage';
import { InterviewVideo } from './InterviewVideo';
import { InterviewContainer } from './Container';
import { usePanoramaContext } from '../../../../utils/hooks/usePanoramaContext';
import { Place } from '../../../../utils/context/PanoramaContext';
import { Paragraph } from '../../../ui/text/Paragraph';
import styled from 'styled-components';
import InterviewIngress from './InterviewIngress';

const Interview: React.FC = () => {
  //console.log('test');
  const params = useParams<{ place: string }>();
  const params2 = useParams<{ brokerProfile: string }>();
  const { getInterview } = usePanoramaContext();
  const interview = getInterview();

  const dangerouslySetInnerHTML: React.FC = (text) => {
    return (
      <>
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </>
    );
  };
  return (
    <Page>
      <Seo
        title={interview?.seo?.title}
        description={interview?.seo.description}
        image={interview?.imageSoMe}
      />
      {/*       {interview?.video ? (
        <InterviewVideo video={interview?.video} />
      ) : interview?.image ? (
        <Hero
          imageUrl={interview?.image}
          className="content-height flex padding-top-50"
          opacity={1}
        ></Hero>
      ) : null} */}
      <InterviewContent>
        <InterviewContainer>
          {interview?.imageOverlay ? (
            <InterviewTypeImage src={interview?.imageOverlay} />
          ) : null}

          <Heading tag="h2" center>
            {interview?.title}
          </Heading>
          {interview?.ingress ? (
            <InterviewIngress>{interview?.ingress}</InterviewIngress>
          ) : null}
          {interview?.quote ? (
            <InterviewQuote quote={interview?.quote} />
          ) : null}
          {interview?.content ? (
            <InterviewTextLeft
              dangerouslySetInnerHTML={{ __html: interview?.content }}
            />
          ) : null}

          {interview?.contentTwo ? (
            <InterviewTextRight
              dangerouslySetInnerHTML={{ __html: interview?.contentTwo }}
            />
          ) : null}
          <ButtonGroup style={{ margin: '2em 0 2em 0' }} className="center">
            <ButtonWrapper>
              <ButtonGroupColumn className="flex-center-mobile">
                <Button
                  className="btn-interview"
                  as="link"
                  type="primary"
                  colorTheme="gold"
                  to={`/kampanje/panorama/${params.place}?map`}
                >
                  Tilbake
                </Button>
              </ButtonGroupColumn>
            </ButtonWrapper>
            <ButtonWrapper>
              <ButtonGroupColumn className="flex-center-mobile">
                <Button
                  className="btn-interview"
                  as="link"
                  type="primary"
                  colorTheme="gold"
                  to={`/megler/${interview?.brokerProfile}?p=0&so=false`}
                >
                  Kontakt
                </Button>
              </ButtonGroupColumn>
            </ButtonWrapper>
          </ButtonGroup>
          <InterviewList
            place={params.place}
            pagination={params.place !== Place.ALLE}
          />
        </InterviewContainer>
      </InterviewContent>
      <FooterOverride />
    </Page>
  );
};

export default Interview;

const ButtonWrapper = styled.div`
  margin: 0.469rem 0.469rem 0.469rem 0.469rem;
  .btn-interview {
    width: 100%;
    text-align: center;
  }
  @media all and (min-width: 300px) {
    margin: 0.469rem 0.469rem 0 0.469rem;
  }
`;
